module.exports = __webpack_public_path__ + "img/无数据@2x.bce92e01.png";